import { useEffect } from 'react';

import type { UtmSearch } from '@/schemas/utm';

import { captureParticipantUtmFromSearch } from '@/utils/participant-utm-storage';

export function useCaptureParticipantUtmFromSearch(
  search: UtmSearch | undefined,
): void {
  useEffect(() => {
    captureParticipantUtmFromSearch(search);
  }, [search]);
}
